import Destacat from 'components/3catinfo/Destacat';
import Mosaic from 'components/3catinfo/Mosaic';
import __isEmpty from 'lodash/isEmpty';

const MosaicDestacatText = (props) => {
    const { items, numColumns, numColumnsMobile } = props;

    return items ? (
        <Mosaic numColumns={numColumns} numColumnsMobile={numColumnsMobile} hGap={300} vGap={400}>
            {items?.map((item) => (
                <Destacat key={`destacat-text-${item.id}`} format='text' {...props} item={item} />
            ))}
        </Mosaic>
    ) : (
        <></>
    );
};

export default MosaicDestacatText;
